import { firestore, User } from 'firebase/app';
import DocumentSnapshot = firestore.DocumentSnapshot;

import { SparkelloUser, UserMapper } from 'sparkello-core';
import { SparkelloWebUser } from '@/web/model/user/SparkelloWebUser';

export class UserWebMapper implements UserMapper<DocumentSnapshot, User> {

  public mapToLocalUser(user: User, doc: DocumentSnapshot): SparkelloUser<User> {
    console.log('RNUserMapper.mapToLocalUser', user, doc?.data());

    const props = doc?.data() ? { ...doc?.data() } : {};
    return new SparkelloWebUser(user, props);
  }

  // eslint-disable-next-line @typescript-eslint/ban-types
  mapToFirestoreUser(user: SparkelloUser<User>): Object {
    return {
      displayName: user.displayName,
      profilePhotoUrl: user.photoUrl,
      bio: user.bio || '',
      location: user.location || '',
      website: user.website || '',
    };
  }
}
